import React from "react";
import { useIntl } from "react-intl";

//Components
import { Switch as Toggle, IconButton, Tooltip } from '@gpstrackit/gtc-react-controls';
import WarningController from './warningController';
import { Grid, Icon } from "@mui/material";

const ADAS = (props) => {
    const { messages } = useIntl();
    const {
        deviceModelSelected,
        setFormDataCamera,
        setCameraChanges,
        formDataCamera,
        setErrors,
        errors,
        unit
    } = props

    //Variables
    let devideModelSupported = ["4K", "AIR1", "AIR2"]
    let adasLevel = formDataCamera?.advanced?.adas?.level === "OFF" ? true : formDataCamera?.noData

    if (!devideModelSupported.includes(unit?.deviceModel || deviceModelSelected?.id)) {
        return (
            <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 10 }}
            >
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                    <p style={{ opacity: 0.5 }}>{messages['cameraSetup_does_not_support']}</p>
                </Grid>
            </Grid>
        )
    }
    return (
        <div style={{ marginTop: 5 }}>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                style={{ marginBottom: 10 }}
            >
                {
                    adasLevel && !formDataCamera?.noData &&
                    <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                        <p style={{ opacity: 0.5 }}>{messages['cameraSetup_adas_off']}</p>
                    </Grid>
                }
                <Grid item xs={5}></Grid>
                <Grid item xs={3} className="camera-setup-header">
                    <label className="label-gtc-rc">{messages['cameraSetup_trigger']}</label>
                    <Tooltip title={messages['cameraSetup_trigger_description']} placement="bottom">
                        <Icon className="camera-setup-helper-icon">help</Icon>
                    </Tooltip>
                </Grid>
                <Grid item xs={3} className="camera-setup-header">
                    <label className="label-gtc-rc">{messages['cameraSetup_warning']}</label>
                    <Tooltip title={messages['cameraSetup_warning_description']} placement="bottom">
                        <Icon className="camera-setup-helper-icon">help</Icon>
                    </Tooltip>
                </Grid>
                <Grid item xs={1} className="camera-setup-header">
                    <label className="label-gtc-rc">{messages['cameraSetup_audio']}</label>
                    <Tooltip title={messages['cameraSetup_audio_description']} placement="bottom">
                        <Icon className="camera-setup-helper-icon">help</Icon>
                    </Tooltip>
                </Grid>
                {/* Forward Collision */}
                <Grid item xs={5}>{messages['cameraSetup_collision_warning']}</Grid>
                <Grid item xs={3}>
                    <Toggle
                        id="collision-warning-trigger"
                        optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                        onChange={(value) => {
                            let forwardCollision = value ? "WARNING" : "OFF"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    ADAS: {
                                        ...prevData?.eventLevel?.ADAS,
                                        FORWARD_COLLISION: forwardCollision
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    ADAS: {
                                        ...prevData?.eventLevel?.ADAS,
                                        FORWARD_COLLISION: forwardCollision
                                    }
                                }
                            }));
                        }}
                        checked={formDataCamera?.eventLevel?.ADAS?.FORWARD_COLLISION === "WARNING" ? true : false}
                        labelPosition="left"
                        style={{ display: 'flex' }}
                        isDisabled={adasLevel}
                    />
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={1}>
                    <IconButton
                        icon={formDataCamera?.sounds?.adas?.FORWARD_COLLISION_WARNING === "on" ? "volume_up" : "volume_off"}
                        onClick={() => {
                            let sound = formDataCamera?.sounds?.adas?.FORWARD_COLLISION_WARNING === "on" ? "off" : "on"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    adas: {
                                        ...prevData?.sounds?.adas,
                                        FORWARD_COLLISION_WARNING: sound
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    adas: {
                                        ...prevData?.sounds?.adas,
                                        FORWARD_COLLISION_WARNING: sound
                                    }
                                }
                            }));
                        }}
                        style={{ color: (formDataCamera?.sounds?.adas?.FORWARD_COLLISION_WARNING === "on" && !adasLevel) && '#66bb6a' }}
                        isDisabled={formDataCamera?.eventLevel?.ADAS?.FORWARD_COLLISION !== "WARNING" || adasLevel}
                        className={(formDataCamera?.eventLevel?.ADAS?.FORWARD_COLLISION !== "WARNING" || adasLevel) ? "camera-setup-sounds-disabled" : ''}
                    />
                </Grid>
                {/* <Grid item xs={5}>{messages['cameraSetup_tailgating']}</Grid>
                <Grid item xs={3}>
                    <Toggle
                        id="tailgating-trigger"
                        optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                        onChange={(value) => {
                            let tailgating = value ? "EMERGENCY" : "OFF"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    ADAS: {
                                        ...prevData?.eventLevel?.ADAS,
                                        HEADWAY_MONITORING: tailgating
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    ADAS: {
                                        ...prevData?.eventLevel?.ADAS,
                                        HEADWAY_MONITORING: tailgating
                                    }
                                }
                            }));
                        }}
                        checked={formDataCamera?.eventLevel?.ADAS?.HEADWAY_MONITORING === "EMERGENCY" ? true : false}
                        labelPosition="left"
                        style={{ display: 'flex' }}
                        isDisabled={adasLevel}
                    />
                </Grid>
                <Grid item xs={3}>
                    <div style={{ width: 70 }}>
                        <WarningController
                            value={formDataCamera?.advanced?.safetyAssistance?.alarm?.TAILGATING}
                            onChange={(value) => {
                                let currentErrors = errors
                                if (value > 10 && !currentErrors.includes("TAILGATING")) {
                                    currentErrors.push("TAILGATING")
                                    setErrors(currentErrors)
                                } else {
                                    let indexCount = currentErrors.findIndex((item) => item === "TAILGATING")
                                    if (indexCount > -1) {
                                        currentErrors.splice(indexCount, 1)
                                    }
                                    setErrors(currentErrors)
                                }
                                setFormDataCamera((prevData) => ({
                                    ...prevData,
                                    advanced: {
                                        ...prevData?.advanced,
                                        safetyAssistance: {
                                            ...prevData?.advanced?.safetyAssistance,
                                            alarm: {
                                                ...prevData?.advanced?.safetyAssistance?.alarm,
                                                TAILGATING: {
                                                    ...prevData?.advanced?.safetyAssistance?.alarm?.TAILGATING,
                                                    cnt: value,
                                                    enable: value ? true : false
                                                }
                                            }
                                        }
                                    }
                                }));
                                setCameraChanges((prevData) => ({
                                    ...prevData,
                                    advanced: {
                                        ...prevData?.advanced,
                                        safetyAssistance: {
                                            ...prevData?.advanced?.safetyAssistance,
                                            alarm: {
                                                ...prevData?.advanced?.safetyAssistance?.alarm,
                                                TAILGATING: {
                                                    ...prevData?.advanced?.safetyAssistance?.alarm?.TAILGATING,
                                                    ...formDataCamera?.advanced?.safetyAssistance?.alarm?.TAILGATING,
                                                    cnt: value ? value : 1,
                                                    enable: value ? true : false
                                                }
                                            }
                                        }
                                    }
                                }));
                            }}
                            isDisabled={adasLevel || formDataCamera?.eventLevel?.ADAS?.HEADWAY_MONITORING === "OFF"}
                        />
                    </div>

                </Grid>
                <Grid item xs={1}>
                    <IconButton
                        icon={formDataCamera?.sounds?.adas?.HEADWAY_MONITORING_EMERGENCY === "on" ? "volume_up" : "volume_off"}
                        onClick={() => {
                            let sound = formDataCamera?.sounds?.adas?.HEADWAY_MONITORING_EMERGENCY === "on" ? "off" : "on"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    adas: {
                                        ...prevData?.sounds?.adas,
                                        HEADWAY_MONITORING_EMERGENCY: sound
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    adas: {
                                        ...prevData?.sounds?.adas,
                                        HEADWAY_MONITORING_EMERGENCY: sound
                                    }
                                }
                            }));
                        }}
                        style={{ color: (formDataCamera?.sounds?.adas?.HEADWAY_MONITORING_EMERGENCY === "on" && !adasLevel) && '#66bb6a' }}
                        isDisabled={formDataCamera?.eventLevel?.ADAS?.HEADWAY_MONITORING !== "EMERGENCY" || adasLevel}
                        className={(formDataCamera?.eventLevel?.ADAS?.HEADWAY_MONITORING !== "EMERGENCY" || adasLevel) ? "camera-setup-sounds-disabled" : ''}
                    />
                </Grid> */}
                {/* Lane Departure */}
                <Grid item xs={5}>{messages['cameraSetup_lane_departure']}</Grid>
                <Grid item xs={3}>
                    <Toggle
                        id="lane-departure-trigger"
                        optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                        onChange={(value) => {
                            let laneDeparture = value ? "WARNING" : "OFF"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData.eventLevel,
                                    ADAS: {
                                        ...prevData?.eventLevel?.ADAS,
                                        LANE_DEPARTURE: laneDeparture
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData.eventLevel,
                                    ADAS: {
                                        ...prevData?.eventLevel?.ADAS,
                                        LANE_DEPARTURE: laneDeparture
                                    }
                                }
                            }));
                        }}
                        checked={formDataCamera?.eventLevel?.ADAS?.LANE_DEPARTURE === "WARNING" ? true : false}
                        labelPosition="left"
                        style={{ display: 'flex' }}
                        isDisabled={adasLevel}
                    />
                </Grid>
                <Grid item xs={3}>
                    <div style={{ width: 70 }}>
                        <WarningController
                            value={formDataCamera?.advanced?.safetyAssistance?.alarm?.LANE_DEPARTURE}
                            onChange={(value) => {
                                let currentErrors = errors
                                if (value > 10 && !currentErrors.includes("LANE_DEPARTURE")) {
                                    currentErrors.push("LANE_DEPARTURE")
                                    setErrors(currentErrors)
                                } else {
                                    let indexCount = currentErrors.findIndex((item) => item === "LANE_DEPARTURE")
                                    if (indexCount > -1) {
                                        currentErrors.splice(indexCount, 1)
                                    }
                                    setErrors(currentErrors)
                                }
                                setFormDataCamera((prevData) => ({
                                    ...prevData,
                                    advanced: {
                                        ...prevData?.advanced,
                                        safetyAssistance: {
                                            ...prevData?.advanced?.safetyAssistance,
                                            alarm: {
                                                ...prevData?.advanced?.safetyAssistance?.alarm,
                                                LANE_DEPARTURE: {
                                                    ...prevData?.advanced?.safetyAssistance?.alarm?.LANE_DEPARTURE,
                                                    cnt: value,
                                                    enable: value ? true : false
                                                }
                                            }
                                        }
                                    }
                                }));
                                setCameraChanges((prevData) => ({
                                    ...prevData,
                                    advanced: {
                                        ...prevData?.advanced,
                                        safetyAssistance: {
                                            ...prevData?.advanced?.safetyAssistance,
                                            alarm: {
                                                ...prevData?.advanced?.safetyAssistance?.alarm,
                                                LANE_DEPARTURE: {
                                                    ...prevData?.advanced?.safetyAssistance?.alarm?.LANE_DEPARTURE,
                                                    ...formDataCamera?.advanced?.safetyAssistance?.alarm?.LANE_DEPARTURE,
                                                    cnt: value ? value : 1,
                                                    enable: value ? true : false
                                                }
                                            }
                                        }
                                    }
                                }));
                            }}
                            isDisabled={adasLevel || formDataCamera?.eventLevel?.ADAS?.LANE_DEPARTURE === "OFF"}
                        />
                    </div>
                </Grid>
                <Grid item xs={1}>
                    <IconButton
                        icon={formDataCamera?.sounds?.adas?.LANE_DEPARTURE_WARNING === "on" ? "volume_up" : "volume_off"}
                        onClick={() => {
                            let sound = formDataCamera?.sounds?.adas?.LANE_DEPARTURE_WARNING === "on" ? "off" : "on"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    adas: {
                                        ...prevData?.sounds?.adas,
                                        LANE_DEPARTURE_WARNING: sound
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    adas: {
                                        ...prevData?.sounds?.adas,
                                        LANE_DEPARTURE_WARNING: sound
                                    }
                                }
                            }));
                        }}
                        style={{ color: (formDataCamera?.sounds?.adas?.LANE_DEPARTURE_WARNING === "on" && !adasLevel) && '#66bb6a' }}
                        isDisabled={formDataCamera?.eventLevel?.ADAS?.LANE_DEPARTURE !== "WARNING" || adasLevel}
                        className={(formDataCamera?.eventLevel?.ADAS?.LANE_DEPARTURE !== "WARNING" || adasLevel) ? "camera-setup-sounds-disabled" : ''}
                    />
                </Grid>
                {/* Stop Sign Violation */}
                <Grid item xs={5}>{messages['cameraSetup_stop_sign_violation']}</Grid>
                <Grid item xs={3}>
                    <Toggle
                        id="stop-sign-violation-trigger"
                        optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                        onChange={(value) => {
                            let stopSignViolation = value ? "WARNING" : "OFF"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData.eventLevel,
                                    ADAS: {
                                        ...prevData?.eventLevel?.ADAS,
                                        STOP_SIGN_VIOLATION: stopSignViolation
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData.eventLevel,
                                    ADAS: {
                                        ...prevData?.eventLevel?.ADAS,
                                        STOP_SIGN_VIOLATION: stopSignViolation
                                    }
                                }
                            }));
                        }}
                        checked={formDataCamera?.eventLevel?.ADAS?.STOP_SIGN_VIOLATION === "WARNING" ? true : false}
                        labelPosition="left"
                        style={{ display: 'flex' }}
                        isDisabled={adasLevel}
                    />
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={1}>
                    <IconButton
                        icon={formDataCamera?.sounds?.adas?.STOP_SIGN_VIOLATION === "on" ? "volume_up" : "volume_off"}
                        onClick={() => {
                            let sound = formDataCamera?.sounds?.adas?.STOP_SIGN_VIOLATION === "on" ? "off" : "on"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    adas: {
                                        ...prevData?.sounds?.adas,
                                        STOP_SIGN_VIOLATION: sound
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    adas: {
                                        ...prevData?.sounds?.adas,
                                        STOP_SIGN_VIOLATION: sound
                                    }
                                }
                            }));
                        }}
                        style={{ color: (formDataCamera?.sounds?.adas?.STOP_SIGN_VIOLATION === "on" && !adasLevel) && '#66bb6a' }}
                        isDisabled={formDataCamera?.eventLevel?.ADAS?.STOP_SIGN_VIOLATION !== "WARNING" || adasLevel}
                        className={(formDataCamera?.eventLevel?.ADAS?.STOP_SIGN_VIOLATION !== "WARNING" || adasLevel) ? "camera-setup-sounds-disabled" : ''}
                    />
                </Grid>

                {/* Pedestrian Collision */}
                <Grid item xs={5}>{messages['cameraSetup_pedestrian_collision']}</Grid>
                <Grid item xs={3}>
                    <Toggle
                        id="pedestrian-collision-trigger"
                        optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                        onChange={(value) => {
                            let stopSignViolation = value ? "WARNING" : "OFF"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData.eventLevel,
                                    ADAS: {
                                        ...prevData?.eventLevel?.ADAS,
                                        PEDESTRIAN_COLLISION: stopSignViolation
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData.eventLevel,
                                    ADAS: {
                                        ...prevData?.eventLevel?.ADAS,
                                        PEDESTRIAN_COLLISION: stopSignViolation
                                    }
                                }
                            }));
                        }}
                        checked={formDataCamera?.eventLevel?.ADAS?.PEDESTRIAN_COLLISION === "WARNING" ? true : false}
                        labelPosition="left"
                        style={{ display: 'flex' }}
                        isDisabled={adasLevel}
                    />
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={1}>
                    <IconButton
                        icon={formDataCamera?.sounds?.adas?.PEDESTRIAN_COLLISION === "on" ? "volume_up" : "volume_off"}
                        onClick={() => {
                            let sound = formDataCamera?.sounds?.adas?.PEDESTRIAN_COLLISION === "on" ? "off" : "on"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    adas: {
                                        ...prevData?.sounds?.adas,
                                        PEDESTRIAN_COLLISION: sound
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    adas: {
                                        ...prevData?.sounds?.adas,
                                        PEDESTRIAN_COLLISION: sound
                                    }
                                }
                            }));
                        }}
                        style={{ color: (formDataCamera?.sounds?.adas?.PEDESTRIAN_COLLISION === "on" && !adasLevel) && '#66bb6a' }}
                        isDisabled={formDataCamera?.eventLevel?.ADAS?.PEDESTRIAN_COLLISION !== "WARNING" || adasLevel}
                        className={(formDataCamera?.eventLevel?.ADAS?.PEDESTRIAN_COLLISION !== "WARNING" || adasLevel) ? "camera-setup-sounds-disabled" : ''}
                    />
                </Grid>

                {/* Cyclist Collision */}
                <Grid item xs={5}>{messages['cameraSetup_cyclist_collision']}</Grid>
                <Grid item xs={3}>
                    <Toggle
                        id="cyclist-collision-trigger"
                        optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                        onChange={(value) => {
                            let stopSignViolation = value ? "WARNING" : "OFF"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData.eventLevel,
                                    ADAS: {
                                        ...prevData?.eventLevel?.ADAS,
                                        CYCLIST_COLLISION: stopSignViolation
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData.eventLevel,
                                    ADAS: {
                                        ...prevData?.eventLevel?.ADAS,
                                        CYCLIST_COLLISION: stopSignViolation
                                    }
                                }
                            }));
                        }}
                        checked={formDataCamera?.eventLevel?.ADAS?.CYCLIST_COLLISION === "WARNING" ? true : false}
                        labelPosition="left"
                        style={{ display: 'flex' }}
                        isDisabled={adasLevel}
                    />
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={1}>
                    <IconButton
                        icon={formDataCamera?.sounds?.adas?.CYCLIST_COLLISION === "on" ? "volume_up" : "volume_off"}
                        onClick={() => {
                            let sound = formDataCamera?.sounds?.adas?.CYCLIST_COLLISION === "on" ? "off" : "on"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    adas: {
                                        ...prevData?.sounds?.adas,
                                        CYCLIST_COLLISION: sound
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    adas: {
                                        ...prevData?.sounds?.adas,
                                        CYCLIST_COLLISION: sound
                                    }
                                }
                            }));
                        }}
                        style={{ color: (formDataCamera?.sounds?.adas?.CYCLIST_COLLISION === "on" && !adasLevel) && '#66bb6a' }}
                        isDisabled={formDataCamera?.eventLevel?.ADAS?.CYCLIST_COLLISION !== "WARNING" || adasLevel}
                        className={(formDataCamera?.eventLevel?.ADAS?.CYCLIST_COLLISION !== "WARNING" || adasLevel) ? "camera-setup-sounds-disabled" : ''}
                    />
                </Grid>
            </Grid>
        </div>
    )
}
export default ADAS